import { render, staticRenderFns } from "./customerDetall.vue?vue&type=template&id=72c36c00&scoped=true&"
import script from "./customerDetall.vue?vue&type=script&lang=js&"
export * from "./customerDetall.vue?vue&type=script&lang=js&"
import style0 from "./customerDetall.vue?vue&type=style&index=0&id=72c36c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c36c00",
  null
  
)

export default component.exports